/**
 * Merkliste
 * ---------------------------------------------------------------------------
 * Speichert gemerkte Produkt-Handles im Browser. Wie beim Newsletter-Popup
 * reicht localStorage allein nicht: Safari raeumt per JavaScript geschriebenen
 * Speicher nach sieben Tagen ohne Besuch ab, und die In-App-Browser von
 * Instagram und Facebook liefern haeufig einen frischen oder gesperrten
 * Speicher. Jeder Stand wird deshalb zusaetzlich in ein Cookie gespiegelt,
 * gelesen wird, was ueberlebt hat.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'floow-wishlist';
  var STORAGE_DAYS = 365;
  var MAX_ITEMS = 100;

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[-.]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    var expires = new Date(new Date().getTime() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function parseList(raw) {
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (handle) {
        return typeof handle === 'string' && handle.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  var Wishlist = {
    get: function () {
      var raw = null;
      try {
        raw = window.localStorage.getItem(STORAGE_KEY);
      } catch (e) {
        // localStorage gesperrt - nur Cookie
      }
      var list = parseList(raw);
      if (!list.length) {
        list = parseList(readCookie(STORAGE_KEY));
      }
      return list;
    },

    save: function (list) {
      var trimmed = list.slice(0, MAX_ITEMS);
      var raw = JSON.stringify(trimmed);
      try {
        window.localStorage.setItem(STORAGE_KEY, raw);
      } catch (e) {
        // localStorage gesperrt - nur Cookie
      }
      // Cookies sind auf rund 4 KB begrenzt. Passt der Stand nicht,
      // wandert wenigstens der juengste Teil hinein.
      var forCookie = trimmed;
      while (forCookie.length && encodeURIComponent(JSON.stringify(forCookie)).length > 3500) {
        forCookie = forCookie.slice(0, -1);
      }
      writeCookie(STORAGE_KEY, JSON.stringify(forCookie), STORAGE_DAYS);
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: trimmed } }));
      return trimmed;
    },

    has: function (handle) {
      return this.get().indexOf(handle) !== -1;
    },

    toggle: function (handle) {
      var list = this.get();
      var index = list.indexOf(handle);
      if (index === -1) {
        list.unshift(handle);
      } else {
        list.splice(index, 1);
      }
      this.save(list);
      return index === -1;
    },

    remove: function (handle) {
      var list = this.get();
      var index = list.indexOf(handle);
      if (index !== -1) {
        list.splice(index, 1);
        this.save(list);
      }
    }
  };

  function paintButton(button, saved) {
    var label = saved ? button.getAttribute('data-label-remove') : button.getAttribute('data-label-add');
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    if (label) {
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    }
  }

  function paintAll() {
    var list = Wishlist.get();
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-toggle]'), function (button) {
      paintButton(button, list.indexOf(button.getAttribute('data-wishlist-handle')) !== -1);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-count]'), function (node) {
      // Nur bei echter Aenderung schreiben, sonst loest der MutationObserver
      // weiter unten sich selbst immer wieder aus
      if (node.textContent !== String(list.length)) {
        node.textContent = list.length;
      }
      node.classList.toggle('is-empty', list.length === 0);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-wishlist-toggle]') : null;
    if (!button) return;

    // Auf der Produktkachel liegt der Button ueber einem Link
    event.preventDefault();
    event.stopPropagation();

    var handle = button.getAttribute('data-wishlist-handle');
    if (!handle) return;

    var saved = Wishlist.toggle(handle);

    // Farbe sofort, danach kurz aufpoppen. Ueber die Web Animations API statt
    // ueber eine CSS-Klasse, damit die Animation bei jedem Klick neu startet.
    paintButton(button, saved);
    pop(button);
    showToast(button, saved);
  });

  function showToast(button, saved) {
    var existing = document.querySelector('.wishlist-toast');
    if (existing) existing.parentNode.removeChild(existing);

    var toast = document.createElement('div');
    var message = saved ? button.getAttribute('data-toast-added') : button.getAttribute('data-toast-removed');
    var linkLabel = button.getAttribute('data-toast-link-label');
    var wishlistUrl = button.getAttribute('data-wishlist-url') || '/pages/merkliste';

    toast.className = 'wishlist-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var text = document.createElement('span');
    text.className = 'wishlist-toast__message';
    text.textContent = message || (saved ? 'Zur Merkliste hinzugefügt.' : 'Von der Merkliste entfernt.');
    toast.appendChild(text);

    if (linkLabel) {
      var link = document.createElement('a');
      link.className = 'wishlist-toast__link';
      link.href = wishlistUrl;
      link.textContent = linkLabel;
      toast.appendChild(link);
    }

    document.body.appendChild(toast);
    window.setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 5000);
  }

  function pop(button) {
    var icon = button.querySelector('svg');
    if (!icon || typeof icon.animate !== 'function') return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    icon.animate([
      { transform: 'scale(1)' },
      { transform: 'scale(1.35)', offset: 0.4 },
      { transform: 'scale(1)' }
    ], { duration: 320, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' });
  }

  document.addEventListener('wishlist:change', paintAll);

  // Zweiter Tab oder zweites Fenster
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) paintAll();
  });

  // Nach Ajax-Nachladen (Filter, Infinite Scroll, Quickbuy) neu einfaerben
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(paintAll, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }

  window.FloowWishlist = Wishlist;
})();
